import { Tooltip, Zoom, IconButton } from '@mui/material';
import { Link } from 'react-router-dom';
import { MdEdit as EditIcon } from 'react-icons/md';
import { useIntl } from 'react-intl';
import { LocalizationIds } from 'helpers/Localizations';


interface IProps {
    link?: string
    stopPropagation?: boolean
    size?: number
    onClick?: () => void
}

let EditIconButton = ({ link, stopPropagation, size, onClick }: IProps) => {
    let { formatMessage } = useIntl();

    return (
        <Tooltip title={formatMessage({ id: LocalizationIds.Edit })} TransitionComponent={Zoom}>
            {link !== undefined && link !== null
                ?
                <IconButton
                    size="small"
                    color="primary"
                    component={Link}
                    to={link || ''}
                    onClick={(ev: any) => {
                        if (stopPropagation === true) {
                            ev.stopPropagation();
                        }
                    }}
                >
                    <EditIcon size={size} />
                </IconButton>
                :
                <IconButton
                    size="small"
                    color="primary"
                    onClick={ev => {
                        if (stopPropagation === true) {
                            ev.stopPropagation();
                        }
                        if (onClick !== undefined && link !== null) {
                            onClick();
                        }
                    }}
                >
                    <EditIcon size={size} />
                </IconButton>
            }
        </Tooltip>
    )
}

export default EditIconButton;